import { ApiError } from '@lib/api/api-response';
import { readApiErrorMessage } from '@lib/api/utils/read-api-error-message';
import 'client-only';

export type FlowDocumentProcessingRealtimeClientToken = {
  key: string;
  apiBaseUrl?: string;
};

export async function fetchFlowDocumentProcessingRealtimeToken(
  flowId: string
): Promise<FlowDocumentProcessingRealtimeClientToken> {
  let response: Response;
  try {
    response = await fetch(
      `/api/flows/${flowId}/document-processing/realtime-token`
    );
  } catch (error) {
    throw error instanceof Error
      ? error
      : new Error('Failed to fetch document processing realtime token');
  }

  if (!response.ok) {
    throw new ApiError(await readApiErrorMessage(response), response.status);
  }

  return response.json() as Promise<FlowDocumentProcessingRealtimeClientToken>;
}
